export default __webpack_public_path__ + "d1873dbfc13217e73c98a70a282063e0.svg";